import {Component, Input, ViewChild, HostListener, Output, EventEmitter, Inject} from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {ApiService} from '../shared/api.service';
import { Utils } from '../utils';

@Component({
    selector: 'site-category',
    templateUrl: 'site-category.component.html'
})
export class SiteCategoryComponent {
    options = [];
    panelOpen = false;

    private _canEdit = false;
    private _listOnly = false;
    private _primaryCats = [];
    private _site;

    @Input('canEdit') 
    set canEdit(canEdit) {
        this._canEdit = canEdit;
    }
    get canEdit() {
        return this._canEdit;
    }
    @Input('listOnly') 
    set listOnly(listOnly) {
        this._listOnly = listOnly;
    }
    get listOnly() {
        return this._listOnly;
    }
    @Input('site') 
    set site(site) {
        this._site = site;
    }
    get site() {
        return this._site;
    }
    @Input('primaryCats') 
    set primaryCats(primaryCats) {
        this._primaryCats = primaryCats;
    }
    get primaryCats() {
        return this._primaryCats;
    }

    @Output() siteChanged = new EventEmitter();

    @ViewChild('dropdown') dropdown;
    @HostListener('document:click', ['$event'])
    clickout(event) {
        if( this.dropdown && !this.dropdown.nativeElement.contains(event.target)) {
            this.panelOpen = false;
        }
    }

    constructor(private api: ApiService, private dialog: MatDialog, public utils: Utils) {}
    ngAfterViewInit() {
        this.options = JSON.parse(JSON.stringify(this.site.categories))
            .map(item => {
                item.checked = true; 
                return item;
            });
        this.getOptions();
    }
    hasPrimaryCats() {
        if( this.site.primary ) {
            return false;
        }
        const slugs = this.primaryCats.map(item => item.slug);
        const siteCats = this.site.categories.filter(item => slugs.indexOf(item.slug) === -1);
        return siteCats.length === 0;
    }
    getOptions() {
        this.api.doAction('post', 'sites', {
            action: 'get_category_options',
            blog_id: this.site.blog_id,
            categories: this.site.categories.length > 0 ? this.site.categories : this.site.primaryCats
        }).subscribe(
            data => {
                if( data.length > 0 ) {
                    this.options = data;
                    if(this.site.categories.filter(category => category.term_id === 1).length === 0) {
                        this.options = this.options.filter(category => category.slug.indexOf('uncategorized') < 0);
                    } 
                    if( this.site.primaryCats ) {
                        this.site.categories = this.options.filter(item => item.checked).map(item => {
                            const newItem = JSON.parse(JSON.stringify(item));
                            delete newItem.checked;
                            return newItem;
                        });
                    }
                    delete this.site.primaryCats;
                }                
            }
        );
    }
    makePrimary(option) {
        const cats = this.site.categories;
        let i = cats.length;
        while(i--) {
            if( cats[i].term_id == option.term_id ) {
                const cat = cats.splice(i, 1);
                cats.unshift(cat[0]);
                this.siteChanged.emit({
                    site: this.site,
                    added: false
                });
                break;
            }
        }
    }
    changeOption(option) {
        const cats = this.site.categories;
        const slugs = cats.map(item => item.slug);
        if( option.checked ) {
            if( slugs.indexOf(option.slug) === -1 ) {
                cats.push({
                    term_id: option.term_id,
                    name: option.name,
                    slug: option.slug
                });
                this.siteChanged.emit({
                    site: this.site,
                    added: true
                });
            }         
        } else {
            let dialog = this.dialog.open(CategoryDialog);
            dialog.afterClosed().subscribe(yes => {
                if( yes ) {
                    let i = cats.length;
                    while(i--) {
                        if( cats[i].term_id == option.term_id ) {
                            cats.splice(i, 1);
                            this.siteChanged.emit({
                                site: this.site,
                                added: false
                            });
                            break;
                        }
                    }
                } else {
                    option.checked = !option.checked;
                }
            });
        }
    }
    togglePanel() {
        this.panelOpen = !this.panelOpen;
    }
    getText() {
        return this.site.categories.map(item => item.name).join(', ');
    }
}

@Component({
    selector: 'category-dialog',
    template: `
        <h2 mat-dialog-title>Are you sure?</h2>
        <mat-dialog-content>Changing the category can be dangerous for sites that use the category in the url.</mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="false">Cancel</button>
            <button class="button" [mat-dialog-close]="true">Yes</button>
        </mat-dialog-actions>`,
})
export class CategoryDialog {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}